import { SavedIcon } from 'components/Button'
import { AutoColumn } from 'components/Column'
import HoverInlineText from 'components/HoverInlineText'
import ListLogo from 'components/ListLogo'
import Loader from 'components/Loader'
import { LoadingOpacityContainer } from 'components/Loader/styled'
import Row, { RowFixed } from 'components/Row'
import { where } from 'firebase/firestore'
import { transparentize } from 'polished'
import { useCollectionQuery, useFetchCollectionQuery } from 'providers/collectionQuery'
import { CollectionInfo } from 'providers/collections'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import Hotkeys from 'react-hot-keys'
import { useSearchBox, UseSearchBoxProps } from 'react-instantsearch-hooks'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { setSearchQuery } from 'state/search/actions'
import { useSearchState } from 'state/search/hooks'
import styled from 'styled-components/macro'
import { CONTENT_LEFT_PADDING, TYPE } from 'theme'

const Container = styled.div`
  position: relative;
  z-index: 30;
  margin: 10px 0px;

  width: 100%;
`

const Wrapper = styled(Row)<{ enabled: boolean }>`
  background-color: ${({ theme, enabled }) => (enabled ? theme.bg2 : transparentize(0.6, theme.bg3))};
  padding: 8px 16px;
  width: 100%;
  margin-left: ${CONTENT_LEFT_PADDING}px;
  height: 45px;
  border-radius: 8px;
  // positon: relative;
  z-index: 9999;

  @media (max-width: 1080px) {
    width: 100%;
  } ;
`

const StyledInput = styled.input<{ enabled: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  white-space: nowrap;
  background: none;
  border: none;
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  outline: none;
  color: ${({ theme, enabled }) => (enabled ? theme.text1 : theme.text3)};

  ::placeholder {
    color: ${({ theme }) => theme.text3};
    font-size: 16px;
  }

  @media screen and (max-width: 640px) {
    ::placeholder {
      font-size: 1rem;
    }
  }
`

const Menu = styled.div<{ hide: boolean }>`
  display: flex;
  flex-direction: column;
  z-index: 9999;
  width: 800px;
  top: 50px;
  max-height: 600px;
  overflow: auto;
  right: 0;
  padding: 1.5rem;
  padding-bottom: 1.5rem;
  position: absolute;
  background: ${({ theme }) => theme.bg0};
  border-radius: 8px;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
    0px 24px 32px rgba(0, 0, 0, 0.04);
  display: ${({ hide }) => hide && 'none'};
  border: 1px solid ${({ theme }) => theme.green1};

  ${({ theme }) => theme.mediaWidth.upToMedium`
    position: absolute;
    margin-top: 4px;
    z-index: 9999;
    width: 100%;
    max-height: 400px;
  `};
`

const Blackout = styled.div`
  position: fixed;
  min-height: 100vh;
  width: 100vw;
  z-index: -40;
  background-color: black;
  opacity: 0.7;
  left: 0;
  top: 0;
`

const ResponsiveGrid = styled.div`
  display: grid;
  grid-gap: 1em;
  grid-template-columns: 1.5fr repeat(3, 1fr);
  align-items: center;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    grid-template-columns: 1fr;
  `};
`

const Break = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.bg1};
  width: 100%;
`

const HoverText = styled.div<{ hide?: boolean | undefined }>`
  color: ${({ theme }) => theme.blue1};
  display: ${({ hide = false }) => hide && 'none'};
  :hover {
    cursor: pointer;
    opacity: 0.6;
  }
`

const HoverRowLink = styled.div`
  :hover {
    cursor: pointer;
    opacity: 0.6;
  }
`

const OptionButton = styled.div<{ enabled: boolean }>`
  width: fit-content;
  padding: 4px 8px;
  border-radius: 8px;
  display: flex;
  font-size: 12px;
  font-weight: 600;
  margin-right: 10px;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme, enabled }) => (enabled ? theme.green1 : 'transparent')};
  color: ${({ theme, enabled }) => (enabled ? theme.white : theme.green1)};
  :hover {
    opacity: 0.6;
    cursor: pointer;
  }
`

export type SearchBoxProps = UseSearchBoxProps

const Search = (props: SearchBoxProps) => {
  const history = useHistory()
  const dispatch = useDispatch()

  const ref = useRef<HTMLInputElement>(null)
  const menuRef = useRef<HTMLDivElement>(null)
  const textRef = useRef<HTMLDivElement>(null)

  const handleDown = useCallback(() => {
    if (ref != null && ref.current !== null) {
      ref.current.focus()
    }
  }, [])

  const [focused, setFocused] = useState<boolean>(false)
  const [showMenu, setShowMenu] = useState(false)
  const [value, setValue] = useState('')
  const { query, refine, isSearchStalled } = useSearchBox(props)

  const { pathname } = useLocation()
  // const collectionQuery = useMemo(() => [where('name', '==', value.toLowerCase())], [value])

  // const [hasFetchedCollectionQuery, setHasFetchedCollectionQuery] = useState(false)
  // const collections = useCollectionQuery(collectionQuery)
  // const fetchCollectionQuery = useFetchCollectionQuery()

  // useEffect(() => {
  // fetchCollectionQuery(collectionQuery)
  //   setHasFetchedCollectionQuery(true)
  // }, [collectionQuery, fetchCollectionQuery, hasFetchedCollectionQuery])

  useEffect(() => {
    if (value !== '') {
      setFocused(true)
    } else {
      setFocused(false)
    }
  }, [value])

  // const filteredCollections = useMemo(() => {
  //   if (value === '') {
  //     return collections?.data?.collections ?? []
  //   }
  //   return (
  //     collections?.data?.collections?.filter((collection) =>
  //       collection.collection?.name?.toLowerCase().includes(value.toLowerCase())
  //     ) ??
  //     // .filter((c) => !COLLECTION_HIDE_LIST.includes(c.collection?.name || ''))
  //     []
  //   )
  // }, [collections, value])

  const [collectionsShown, setCollectionsShown] = useState(3)

  const handleClick = (e: any) => {
    if (!(menuRef.current && menuRef.current.contains(e.target)) && !(ref.current && ref.current.contains(e.target))) {
      setCollectionsShown(3)
      setShowMenu(false)
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClick)
    return () => {
      document.removeEventListener('click', handleClick)
    }
  })

  const searchState = useSearchState()
  useEffect(() => {
    if (searchState.query !== value) {
      // refine(value)
      dispatch(setSearchQuery(value))
    }
  }, [dispatch, searchState.query, value])

  // watchlist
  // const [savedTokens, addSavedToken] = useSavedTokens()
  // const [savedPools, addSavedPool] = useSavedPools()

  const handleNav = (to: string) => {
    setShowMenu(false)
    setCollectionsShown(3)
    history.push(to)
  }

  // get date for watchlist
  // const watchListTokenData = useTokenDatas(savedTokens)
  // const watchListPoolData = usePoolDatas(savedPools)

  // filter on view
  // const [showWatchlist, setShowWatchlist] = useState(false)
  // const tokensForList = useMemo(
  //   () => (showWatchlist ? watchListTokenData ?? [] : tokens.sort((t0, t1) => (t0.volumeUSD > t1.volumeUSD ? -1 : 1))),
  //   [showWatchlist, tokens, watchListTokenData]
  // )
  // const poolForList = useMemo(
  //   () => (showWatchlist ? watchListPoolData ?? [] : pools.sort((p0, p1) => (p0.volumeUSD > p1.volumeUSD ? -1 : 1))),
  //   [pools, showWatchlist, watchListPoolData]
  // )

  return (
    <Hotkeys keyName="command+/" onKeyDown={handleDown}>
      {/* {showMenu ? <Blackout /> : null} */}
      <Container>
        <Wrapper enabled={focused}>
          <StyledInput
            type="text"
            value={value}
            onChange={(e) => {
              setValue(e.target.value)
            }}
            placeholder="Search All of Solana"
            ref={ref}
            onFocus={() => {
              setFocused(true)
              setShowMenu(true)
            }}
            onBlur={() => setFocused(false)}
            enabled={focused}
            onKeyDown={(e) => {
              if (!pathname.includes('/explore')) {
                history.push(`/explore/mints`)
              }
              // dispatch(setSearchQuery(value))
            }}
          />
          {!focused && <TYPE.gray pl="2px">⌘/</TYPE.gray>}
        </Wrapper>
        {/* <Menu hide={!showMenu} ref={menuRef}>
          <AutoColumn gap="lg">
            <AutoColumn gap="sm">
              <RowFixed>
                <OptionButton
                  enabled={!true}
                  onClick={() => {
                    return
                  }}
                >
                  Search
                </OptionButton>
                <OptionButton
                  enabled={true}
                  onClick={() => {
                    return
                  }}
                >
                  Watchlist
                </OptionButton>
              </RowFixed>
            </AutoColumn>
            <ResponsiveGrid>
              <TYPE.main>Collections</TYPE.main>
            </ResponsiveGrid>
            {filteredCollections.slice(0, collectionsShown).map((c: CollectionInfo, i: number) => {
              const collection = c.collection
              if (!collection) return <Loader></Loader>
              return (
                <HoverRowLink onClick={() => handleNav('collections/' + c.id)} key={i}>
                  <ResponsiveGrid>
                    <RowFixed>
                      {collection.image ? (
                        <ListLogo
                          size="24px"
                          style={{ marginRight: '0.5rem', borderRadius: '20px' }}
                          logoURI={collection.image}
                          alt={`${collection.name} collection logo`}
                        />
                      ) : (
                        <LoadingOpacityContainer
                          $loading={true}
                          style={{ width: '24px', height: '20px', marginRight: '0.5rem' }}
                        ></LoadingOpacityContainer>
                      )}
                      <TYPE.label ml="10px">
                        <HoverInlineText text={`${collection.name}`} />
                      </TYPE.label>
                      <SavedIcon
                        id="watchlist-icon"
                        size={'16px'}
                        style={{ marginLeft: '8px' }}
                        fill={false}
                        onClick={(e) => {
                          e.stopPropagation()
                        }}
                      />
                    </RowFixed>
                  </ResponsiveGrid>
                </HoverRowLink>
              )
            })}
            {filteredCollections.length === 0 ? <TYPE.main>No results</TYPE.main> : null}
            <HoverText
              onClick={() => {
                setCollectionsShown(collectionsShown + 5)
              }}
              hide={!(filteredCollections.length > 3 && filteredCollections.length >= collectionsShown)}
              ref={textRef}
            >
              See more...
            </HoverText>
            <Break />
          </AutoColumn>
        </Menu> */}
      </Container>
    </Hotkeys>
  )
}

export default Search
